import React, { useState } from 'react';

// 珠宝鉴定机构数据
const institutionsData = [
  {
    id: 1,
    name: '国家珠宝玉石质量监督检验中心',
    region: '北京市',
    address: '北京市东城区北三环东路36号环球贸易中心C座22层',
    phone: '010-64273637',
    website: 'http://www.ngtc.com.cn/',
    description: '国内最权威的珠宝鉴定机构之一，成立于1993年，是国家质量监督检验检疫总局依法授权的国家级珠宝玉石专业质检机构。'
  },
  {
    id: 2,
    name: '国家首饰质量监督检验中心',
    region: '北京市',
    address: '北京市朝阳区大屯路甲2号',
    phone: '010-58276000',
    website: 'http://www.njc.com.cn/',
    description: '成立于1985年，是国家质量监督检验检疫总局依法授权的国家级质检机构，主要从事首饰产品质量监督检验、仲裁检验、委托检验等。'
  },
  {
    id: 3,
    name: '上海市珠宝玉石质量监督检验站',
    region: '上海市',
    address: '上海市南京东路432号',
    phone: '021-63553020',
    website: 'http://www.shjyjc.com/',
    description: '上海市质量技术监督局依法授权的珠宝玉石质量监督检验机构，主要从事珠宝玉石、贵金属首饰的质量检验工作。'
  },
  {
    id: 4,
    name: '广东省珠宝玉石及贵金属检测中心',
    region: '广东省',
    address: '广州市越秀区东风东路751号',
    phone: '020-87691899',
    website: 'http://www.gtc-china.cn/',
    description: '成立于1995年，是广东省质量技术监督局依法授权的珠宝玉石及贵金属检测机构，是华南地区最具规模的珠宝检测机构之一。'
  },
  {
    id: 5,
    name: '云南省珠宝玉石质量监督检验研究院',
    region: '云南省',
    address: '昆明市北京路1085号',
    phone: '0871-63149823',
    website: 'http://www.ynzjyjc.com/',
    description: '云南省质量技术监督局依法授权的珠宝玉石质量监督检验机构，是西南地区最具影响力的珠宝检测机构之一。'
  }
];

const AppraisalInstitutions = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredInstitutions, setFilteredInstitutions] = useState(institutionsData);

  // 处理搜索
  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    
    if (term === '') {
      setFilteredInstitutions(institutionsData);
    } else {
      const filtered = institutionsData.filter(institution => 
        institution.name.includes(term) || 
        institution.region.includes(term) ||
        institution.address.includes(term)
      );
      setFilteredInstitutions(filtered);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8 text-indigo-800">
          珠宝鉴定机构目录
        </h1>
        
        {/* 搜索框 */}
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 mb-8 border border-purple-100">
          <div className="relative">
            <input
              type="text"
              placeholder="按名称、地区或地址搜索..."
              value={searchTerm}
              onChange={handleSearch}
              className="w-full px-4 py-3 pl-12 rounded-lg border border-purple-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
            />
            <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400">
              🔍
            </div>
          </div>
        </div>

        {/* 机构列表 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {filteredInstitutions.map((institution) => (
            <div key={institution.id} className="bg-white rounded-xl shadow-lg p-6 border border-purple-100">
              <h2 className="text-xl font-semibold mb-2 text-indigo-700">
                {institution.name}
              </h2>
              <div className="text-gray-600 mb-1">
                <strong>地区：</strong>{institution.region}
              </div>
              <div className="text-gray-600 mb-3">
                <strong>地址：</strong>{institution.address}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <strong>电话：</strong>
                  <a href={`tel:${institution.phone}`} className="text-purple-600 hover:underline">
                    {institution.phone}
                  </a>
                </div>
                <div>
                  <strong>官网：</strong>
                  <a 
                    href={institution.website} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-purple-600 hover:underline"
                  >
                    {institution.website}
                  </a>
                </div>
              </div>
              <div className="text-gray-600">
                <strong>简介：</strong>{institution.description}
              </div>
            </div>
          ))}
        </div>

        {/* 搜索结果为空时的提示 */}
        {filteredInstitutions.length === 0 && (
          <div className="bg-white rounded-xl shadow-lg p-8 text-center border border-purple-100 mt-6">
            <p className="text-gray-600">未找到匹配的鉴定机构</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppraisalInstitutions;